import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NotificationType } from '../../enums/notification-type.enum';
import { NotificationToast } from '../../interfaces/NotificationToast.interface';
import { AumicoCoreProvider } from '../../provider/aumico.core.provider';

@UntilDestroy()
@Component({
    selector: 'aum-notification-toast',
    styleUrls: ['./notification-toast.scss'],
    templateUrl: './notification-toast.html',
})
export class AumNotificationToast implements OnInit {
    toasts: NotificationToast[] = [];
    autoHide: boolean = true;
    notificationType = NotificationType;

    constructor(private coreProvider: AumicoCoreProvider) {}

    ngOnInit() {
        this.coreProvider
            .getNotifications()
            .pipe(untilDestroyed(this))
            .subscribe((notifications) => {
                this.toasts = notifications.reverse();
            });
    }

    closeNotification(notificationId: string): void {
        this.coreProvider.dispatchCloseNotification(notificationId);
    }

    /**
     * REV-21374 — meldet die Handlung und schliesst den Toast.
     *
     * ⚠️ Schliessen gehoert dazu: ein Toast, der nach „Rueckgaengig" stehen bleibt, laedt zum
     * zweiten Klick ein — und der zweite Klick macht die Ruecknahme wieder rueckgaengig.
     */
    triggerAction(toast: NotificationToast): void {
        if (!toast.actionId) {
            return;
        }
        this.coreProvider.dispatchNotificationAction(toast.actionId);
        this.closeNotification(toast.id);
    }

    stopAutoHide(): void {
        this.autoHide = false;
    }

    startAutoHide(): void {
        this.autoHide = true;
    }
}
